<template>
<div class="popup" v-cloak v-show="taskSchduleShow" @click="reSet()">
    <div class="content" id="taskSchdule">
        <div class="title">
            {{$t('language.popup.cloudTransferPopup.schedule')}}
            <div class="icon white-close dialog-close" @click.stop="scheduleClose()"></div>
        </div>
        <div class="task-schdule-body">
            <div class="schedule-content">
                <div class="schedule-content-item">
                    <div class="schedule-content-name">{{$t('language.common.frequency')}}</div>
                    <div class="schedule-selects">
                        <el-select class="schedule-select" v-model="activeName">
                            <div v-for="type in schedulesTypes" :key="type.id">
                                <el-option v-if="activeName!=type.id" :label="$t('language.popup.'+type.type)" :value="type.id"></el-option>
                            </div>
                        </el-select>
                    </div>
                </div>
                <div class="schedule-content-item">
                    <div class="schedule-content-name">{{$t('language.common.startTime')+":"}}</div>
                    <div class="schedule-items">
                        <tab1 ref="once" :disable="activeName == 1"></tab1>
                        <tab2 ref="daily" :disable="activeName == 2"></tab2>
                        <tab3 ref="weekly" :disable="activeName == 3"></tab3>
                        <tab4 ref="monthly" :disable="activeName == 4"></tab4>
                    </div>
                </div>
            </div>
            <div class="schedule-footer">
                <button class="schedule-save" @click.stop="saveSchdule()">{{$t('language.common.save')}}</button>
                <button class="schedule-save white-button" style="margin-right:10px;" @click.stop="scheduleClose()">{{$t('language.common.cancel')}}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import tab1 from "@/components/common/tabs/tabs_transfer_schedule/tab_once";
import tab2 from "@/components/common/tabs/tabs_transfer_schedule/tab_daily";
import tab3 from "@/components/common/tabs/tabs_transfer_schedule/tab_weekly";
import tab4 from "@/components/common/tabs/tabs_transfer_schedule/tab_monthly";
import commonUtils from "@/js/workspace/common_util.js";
export default {
    props:["schedules"],
    components: {
        tab1,
        tab2,
        tab3,
        tab4,
    },
    data: function () {
        return {
            activeName: null,
            taskSchduleShow: false,
            schedulesTypes: [{id:1,type:'once'},{id:2,type:'daily'},{id:3,type:'weekly'},{id:4,type:'monthly'}],
        }
    },
    methods: {
        //重置整个弹框的数据
        reSet() {
            window.getSelection().empty();
            // this.initPopup();
        },
        //单次任务校验是否无法执行
        validatorTime(date,time){
            var timeValue = date + ' ' + time;
            var myDate = new Date();
            var now = myDate.valueOf();
            var time = new Date(timeValue).valueOf();
            if(now > time){
                return true;
            }else{
                return false;
            }
        },
        saveSchdule() {
            let that = this;
            //可以保存定时计划任务执行时，提示需要付费才能使用
            if (!commonUtils.getUser().vip) {
                var upgradeNewDialog = this.$parent.$refs.upgradeNewDialog;
                upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_scheduled');
                upgradeNewDialog.curItem = 'scheduled';
                upgradeNewDialog.isShow = true;
                return false;
            }
            let schedules;
            switch (this.activeName) {
                case 1:
                    schedules = this.$refs.once.getRunTime();
                    if(this.validatorTime(schedules.date,schedules.times[0])) {
                        this.$toast({
                            text: this.$t('language.teamTransfer.timePassed'),
                            type: 'fail',
                            idValue: "taskSchdule"
                        });
                        return false;
                    }
                    break;
                case 2:
                    schedules = this.$refs.daily.getRunTime();
                    break;
                case 3:
                    schedules = this.$refs.weekly.getRunTime();
                    break;
                case 4:
                    schedules = this.$refs.monthly.getRunTime();
                    break;
                default:
                    this.$toast({
                        text: this.$t('language.teamTransfer.timePassed'),
                        type: 'fail',
                        idValue: "taskSchdule"
                    });
                    return false;
            }

            if(schedules) {
                //设置服务器时间
                schedules.clientTime = commonUtils.getNowDateFormat();
                this.$parent.pSchedules = schedules;
                this.$parent.checkedSchedule = true;
                this.taskSchduleShow = false;
            }else {
                this.$toast({
                    text: "未选择时间",
                    type: 'fail',
                    idValue: "allBox"
                });
            }
        },
        scheduleClose() {
            //关闭界面时恢复用户之前选择的数据
            this.taskSchduleShow = false;
        },
        initPopup() {
            //初始化当前数据
            let schedules = this.$parent.pSchedules
            if(schedules){
                //加载记录
                switch (schedules.type) {
                    case "Once":
                        this.activeName = 1;
                        break;
                    case "Daily":
                        this.activeName = 2;
                        break;
                    case "Weekly":
                        this.activeName = 3;
                        break;
                    case "Monthly":
                        this.activeName = 4;
                        break;
                    default:
                        this.activeName = 1;
                        break;
                }
            }else {
                this.activeName = 1;
            }
            this.$refs.once.initDate(this.activeName==1?schedules:null);
            this.$refs.daily.initDate(this.activeName==2?schedules:null);
            this.$refs.weekly.initDate(this.activeName==3?schedules:null);
            this.$refs.monthly.initDate(this.activeName==4?schedules:null);
        }
    },
}
</script>

<style>
#taskSchdule {
    width: 420px;
    /*no*/
    height: 442px;
    /*no*/
}

.task-schdule-body {
    width: 100%;
    height: calc(100% - 40px);
    /*no*/
    box-sizing: border-box;
    padding: 20px;
    /*no*/
}

.schedule-content {
    display: flex;
    flex-direction: column;
    font-family: PingFang SC;
    font-size: 14px;
    /*no*/
    font-weight: normal;
    line-height: 32px;
    /*no*/
    text-align: right;
    letter-spacing: 0em;
    color: #565D66;
}

.schedule-content-name {
    white-space: nowrap;
    line-height: 20px;/*no*/
    height: 25px;/*no*/
}

.schedule-selects {
    margin-bottom: 30px;
    /*no*/
}

.schedule-items {
    display: flex;
    align-items: center;
}

.schedule-content-item {
    flex-grow: 1;
    text-align: left;
}

.schedule-select {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.schedule-content-item .el-input {
    width: 100%;
    height: 30px;
    /*no*/
}

.schedule-content-item .el-input input{
    width: 100%;
    margin: 0;
    height: 30px;
    /*no*/
    border-radius: 0;
    border: 1px solid #D3DCF0;/*no*/
}

.schedule-footer {
    position: absolute;
    bottom: 20px;
    /*no*/
    right: 20px;
    /*no*/
    width: auto;
    height: auto;
}

.el-scrollbar .el-scrollbar__wrap{
    margin-bottom: 0 !important;
    /*no*/
}

.el-input__icon {
    line-height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_transfer_popups/task_schedule_popup.vue